import React from "react";
import { makeStyles } from "@mui/styles";
import CustomAvatar from "../../../general_components/CustomAvatar";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import {Typography} from "@mui/material";
import {useTheme } from "@mui/material/styles";
import { getAPIEndpointUrl } from "../../../utils/ServerRequestModifier";

const useStyles = makeStyles({
  image: {
    width: "100%",
    height: 150,
    minHeight: 150,
    borderRadius: 15,
    position: "absolute",
    backgroundColor: "#eee",
    objectFit: "cover",
    resizeMode: "contain",
  },
});


export default function AddCardImage({
  setRawImage,
  image,
  setImage,
  isNewsFile,
  editMode,
  setIsNewsFile,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const ref = React.useRef(null);

  const getProfileImageFile = async (e1, name) => {
    var file = e1.target.files[0];
    if (file !== undefined) {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        fileType: "JPEG",
      };

      try {
        var fr = new FileReader();
        fr.onload = function (e) {
          setRawImage({
            image: e.target.result,
            file: new File([file], "image.jpeg"),
          });
          setImage(e.target.result);
        };
        fr.readAsDataURL(file);
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <div>
      <Typography
          variant={"caption"}
          style={{ lineHeight: 1 }}
          color={"textSecondary"}
      >
        Card Image
      </Typography>
      <div
        style={{
          display: "flex",
          justifyContent: isNewsFile ? "center" : "flex-start",
        }}
      >
        <input
          ref={ref}
          style={{ display: "none" }}
          onChange={(e) => getProfileImageFile(e)}
          type={"file"}
          required={true}
        />
        <div style={{ position: "relative" }}>
            <CustomAvatar
                avatar={ editMode === true? getAPIEndpointUrl()+image : image}
                imageStyle={{
                    width: 250, height: 150,
                    minHeight: 100,
                    borderRadius: "5px",
                    objectFit: "cover",
                    cursor: "pointer",
                }}
                handleClick={() => ref.current.click()}
                alphaImageStyle={{ width: 100, height: 100, bgcolor: "#FFFFFF" }}
                child={<InsertPhotoIcon sx={{ fontSize: 60 }} />}
            />
        </div>
      </div>
    </div>
  );
}
